import type { DataResponse } from "@common/features/User";

type AuthRouteUser = {
  account_type?: string;
  mobile?: string | null;
  mobile_verified?: boolean;
  email_verified?: boolean;
};

export type PrivateRouteDecision =
  | { type: "allow" }
  | { type: "forbidden" }
  | { type: "redirect"; pathname: string };

export function isAdminRouteBootstrapReady(data?: DataResponse) {
  if (!data?.user || !data.permissions || !data.masterPermissions) {
    return false;
  }

  if (data.user.account_type === "member") {
    return true;
  }

  return !!data.masterUser;
}

export function getPrivateRouteDecision({
  user,
  verify = true,
  admin = false,
  mobileVerificationEnabled,
  emailVerificationEnabled,
}: {
  user?: AuthRouteUser | null;
  verify?: boolean;
  admin?: boolean;
  mobileVerificationEnabled: boolean;
  emailVerificationEnabled: boolean;
}): PrivateRouteDecision {
  if (!user) {
    return { type: "redirect", pathname: "/login" };
  }

  if (!verify) {
    return { type: "allow" };
  }

  if (admin && user.account_type === "member") {
    return { type: "forbidden" };
  }

  if (
    mobileVerificationEnabled &&
    "mobile_verified" in user &&
    !user.mobile_verified
  ) {
    return {
      type: "redirect",
      pathname: user.mobile ? "/verify" : "/complete",
    };
  }

  if (
    emailVerificationEnabled &&
    "email_verified" in user &&
    !user.email_verified
  ) {
    return { type: "redirect", pathname: "/verify-email" };
  }

  return { type: "allow" };
}
